/**
 * Groups items under their category, in the order the categories are given
 * (the viewed questionnaire's own arranged order). Item order within a group is
 * preserved. Empty categories are dropped. Items whose category_id matches no
 * category are collected into a trailing group labelled "—".
 */
export function groupByCategoryOrdered<T extends { category_id: string | null }>(
  items: T[],
  categories: { id: string; name: string }[],
): { id: string; name: string; items: T[] }[] {
  const groups: { id: string; name: string; items: T[] }[] = [];
  const known = new Set(categories.map((c) => c.id));

  for (const cat of categories) {
    const inCat = items.filter((i) => i.category_id === cat.id);
    if (inCat.length > 0) groups.push({ id: cat.id, name: cat.name, items: inCat });
  }

  const orphans = items.filter((i) => i.category_id === null || !known.has(i.category_id));
  if (orphans.length > 0) groups.push({ id: '__uncategorized__', name: '—', items: orphans });

  return groups;
}
